import { render } from "./DynamicFields.vue?vue&type=template&id=6bcdcd82"
import script from "./DynamicFields.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicFields.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/DynamicFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bcdcd82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bcdcd82', __exports__)) {
    api.reload('6bcdcd82', __exports__)
  }
  
  module.hot.accept("./DynamicFields.vue?vue&type=template&id=6bcdcd82", () => {
    api.rerender('6bcdcd82', render)
  })

}


export default __exports__